import React from 'react';

const ReposIpfsShipyardIpfsCss = () => (
  <div id='content' className='pt3 pr4 pl4 w-100'>
    <h1><span className='nav-category'>Repo:</span> ipfs-shipyard/ipfs-css</h1>

    <p>This repo contains the source code for single-purpose CSS class names and <code>font-face config</code> for easy IPFS UI theming. <a href="https://github.com/ipfs-shipyard/ipfs-css" target="_blank" rel="noopener noreferrer">View on GitHub</a></p>

    <h2>Nothing to see here!</h2>
    <p>This repo isn’t examined in detail because its code is primarily used as a constituent part of one or more other user-facing repos.</p>
  </div>
);

export default ReposIpfsShipyardIpfsCss;
